/*
  Add here your own custom javascript codes
*/

/* PCL — Quantity prompt for product-card add-to-cart.
   Intercepts .product-card-form submits (collection pages,
   cross-sells, recommendations) and shows a quantity dialog
   before adding to cart. Product detail page uses a
   different form (product-block-buy-buttons) so is unaffected. */
(function () {
  'use strict';

  var MODAL_HTML = '' +
    '<div id="pcl-qty-modal" class="pcl-qty-modal" hidden aria-hidden="true">' +
      '<div class="pcl-qty-modal-backdrop" data-pcl-close></div>' +
      '<div class="pcl-qty-modal-content" role="dialog" aria-modal="true" aria-labelledby="pcl-qty-modal-title">' +
        '<button type="button" class="pcl-qty-modal-close" aria-label="Close" data-pcl-close>&times;</button>' +
        '<div class="pcl-qty-modal-body">' +
          '<img class="pcl-qty-modal-image" src="" alt="" />' +
          '<h3 id="pcl-qty-modal-title" class="pcl-qty-modal-title"></h3>' +
          '<p class="pcl-qty-modal-variant"></p>' +
          '<p class="pcl-qty-modal-price"></p>' +
          '<div class="pcl-qty-modal-oos" data-pcl-qty-oos hidden>' +
            '<div class="pcl-qty-modal-oos__label">Out of Stock</div>' +
            '<div class="pcl-qty-modal-oos__date" data-pcl-qty-oos-date></div>' +
            '<div class="pcl-qty-modal-oos__note" data-pcl-qty-oos-note></div>' +
          '</div>' +
          '<label class="pcl-qty-label">Quantity</label>' +
          '<div class="pcl-qty-stepper">' +
            '<button type="button" class="pcl-qty-btn" data-pcl-dec aria-label="Decrease">&minus;</button>' +
            '<input type="number" class="pcl-qty-input" value="1" min="1" max="999" inputmode="numeric" />' +
            '<button type="button" class="pcl-qty-btn" data-pcl-inc aria-label="Increase">+</button>' +
          '</div>' +
          '<button type="button" class="pcl-qty-confirm">Add to cart</button>' +
          '<p class="pcl-qty-error" hidden></p>' +
        '</div>' +
      '</div>' +
    '</div>';

  // PCL 2026-05-04: inline styles for the OOS notice inside the qty modal.
  // Self-contained so we don't have to modify custom.css.
  var OOS_STYLE = '' +
    '.pcl-qty-modal-oos{margin:0.5rem 0 0.75rem;padding:0.625rem 0.75rem;border-radius:0.5rem;background:#fef2f2;border:1px solid #fecaca;color:#991b1b;text-align:left;}' +
    '.pcl-qty-modal-oos[hidden]{display:none;}' +
    '.pcl-qty-modal-oos__label{display:inline-block;background:#b91c1c;color:#fff;font-weight:700;font-size:0.6875rem;letter-spacing:0.05em;padding:0.1875rem 0.5rem;border-radius:0.25rem;text-transform:uppercase;margin-bottom:0.375rem;}' +
    '.pcl-qty-modal-oos__date{font-weight:600;font-size:0.875rem;color:#1f2937;margin-bottom:0.125rem;}' +
    '.pcl-qty-modal-oos__date:empty{display:none;}' +
    '.pcl-qty-modal-oos__note{font-size:0.8125rem;color:#4b5563;line-height:1.4;}' +
    '.pcl-qty-modal-oos__note:empty{display:none;}';

  var currentForm = null;
  var modal, titleEl, imgEl, variantEl, priceEl, qtyInput, confirmBtn, errorEl, oosEl, oosDateEl, oosNoteEl;

  function init() {
    // Inject inline styles for the OOS notice (idempotent — only once)
    if (!document.getElementById('pcl-qty-oos-style')) {
      var styleEl = document.createElement('style');
      styleEl.id = 'pcl-qty-oos-style';
      styleEl.textContent = OOS_STYLE;
      document.head.appendChild(styleEl);
    }

    var container = document.createElement('div');
    container.innerHTML = MODAL_HTML;
    document.body.appendChild(container.firstChild);

    modal      = document.getElementById('pcl-qty-modal');
    titleEl    = modal.querySelector('.pcl-qty-modal-title');
    imgEl      = modal.querySelector('.pcl-qty-modal-image');
    variantEl  = modal.querySelector('.pcl-qty-modal-variant');
    priceEl    = modal.querySelector('.pcl-qty-modal-price');
    qtyInput   = modal.querySelector('.pcl-qty-input');
    confirmBtn = modal.querySelector('.pcl-qty-confirm');
    errorEl    = modal.querySelector('.pcl-qty-error');
    oosEl      = modal.querySelector('[data-pcl-qty-oos]');
    oosDateEl  = modal.querySelector('[data-pcl-qty-oos-date]');
    oosNoteEl  = modal.querySelector('[data-pcl-qty-oos-note]');

    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-pcl-close')) closeModal();
    });
    modal.querySelector('[data-pcl-dec]').addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    modal.querySelector('[data-pcl-inc]').addEventListener('click', function () {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });
    confirmBtn.addEventListener('click', submitAdd);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!form.closest('.product-card-form')) return;
      // Skip forms inside the cart drawer (upsells, gift picker, etc.) — the
      // native cart flow handles those and the popup would sit on top of the
      // drawer and block it.
      if (form.closest('#cart-drawer, cart-component, .cart-upsells, .cart-gift-upsell')) return;
      var addBtn = form.querySelector('button[name="add"]');
      if (!addBtn || addBtn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      openModal(form);
    }, true);
  }

  function openModal(form) {
    currentForm = form;
    var card = form.closest('.product-card');

    var title = '';
    var titleLink = card && card.querySelector('.product-card-link');
    if (titleLink) title = (titleLink.textContent || '').trim();

    var imgSrc = '';
    var imgTag = card && card.querySelector('.img-wrapper img');
    if (imgTag) imgSrc = imgTag.currentSrc || imgTag.src || '';

    var priceText = '';
    var priceTag = card && card.querySelector('.price');
    if (priceTag) {
      // Read only the actual price value from the [data-price] span — skip all
      // the visually-hidden screen-reader labels and the compare/duplicate markup.
      var priceValueEl = priceTag.querySelector('span[data-price]');
      if (priceValueEl) {
        priceText = priceValueEl.textContent.replace(/\s+/g, ' ').trim();
        // Prefix with "From" only when the product actually has price variance.
        if (priceTag.getAttribute('data-price-varies') === 'true' && priceText) {
          priceText = 'From ' + priceText;
        }
      }
    }

    var variantLabel = '';
    var select = form.querySelector('select[name="id"]');
    if (select && select.options[select.selectedIndex]) {
      variantLabel = select.options[select.selectedIndex].textContent.trim();
    }

    titleEl.textContent   = title;
    variantEl.textContent = variantLabel;
    priceEl.textContent   = priceText;
    if (imgSrc) { imgEl.src = imgSrc; imgEl.hidden = false; } else { imgEl.hidden = true; }
    qtyInput.value = 1;
    errorEl.hidden = true;
    errorEl.textContent = '';
    confirmBtn.disabled = false;
    confirmBtn.textContent = 'Add to cart';

    // PCL 2026-05-04: show OOS notice for the selected variant if the product
    // has OOS metafields configured. Reads per-variant data emitted by
    // product-card-form.liquid into a [data-pcl-qv-oos-data] script tag inside
    // the same product card.
    if (oosEl) {
      oosEl.hidden = true;
      if (oosDateEl) oosDateEl.textContent = '';
      if (oosNoteEl) oosNoteEl.textContent = '';
      try {
        var oosScript = card && card.querySelector('[data-pcl-qv-oos-data]');
        if (oosScript) {
          var oosData = JSON.parse(oosScript.textContent);
          var variantInput = form.querySelector('[name="id"]');
          var vid = variantInput ? variantInput.value : '';
          var v = oosData[vid];
          if (v && v.managed && v.qty <= 0 && (v.note || v.ship_date)) {
            oosEl.hidden = false;
            if (oosDateEl && v.ship_date) oosDateEl.textContent = 'Expected to ship: ' + v.ship_date;
            if (oosNoteEl && v.note) oosNoteEl.textContent = v.note;
          }
        }
      } catch (oosErr) {
        // non-fatal: leave OOS hidden if parsing fails
      }
    }

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { qtyInput.focus(); qtyInput.select(); }, 50);
  }

  function closeModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    currentForm = null;
  }

  function submitAdd() {
    if (!currentForm) return;
    var variantInput = currentForm.querySelector('[name="id"]');
    var variantId = variantInput ? variantInput.value : '';
    var quantity  = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    if (!variantId) return;

    confirmBtn.disabled = true;
    confirmBtn.textContent = 'Adding…';
    errorEl.hidden = true;

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', quantity);

    // Delegate to the theme's own cart-component so Section Rendering API
    // refreshes the cart drawer (items, totals, goal, upsells) and opens it
    // — same path the theme uses for its native add-to-cart.
    var cartComponent = document.querySelector('#cart-drawer cart-component');
    if (cartComponent && typeof cartComponent.add === 'function') {
      var onAdded, onError, cleanup;
      cleanup = function () {
        window.removeEventListener('cart:added', onAdded);
        window.removeEventListener('cart:error', onError);
      };
      onAdded = function () {
        cleanup();
        closeModal();
      };
      onError = function (ev) {
        cleanup();
        var msg = (ev && ev.detail && (ev.detail.description || ev.detail.message)) || 'Could not add to cart.';
        errorEl.textContent = msg;
        errorEl.hidden = false;
        confirmBtn.disabled = false;
        confirmBtn.textContent = 'Add to cart';
      };
      window.addEventListener('cart:added', onAdded);
      window.addEventListener('cart:error', onError);
      cartComponent.add(body);
      return;
    }

    // Fallback for pages without the cart-component (shouldn't happen in
    // normal storefront flow, but keeps this resilient).
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
    .then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    })
    .then(function (result) {
      if (!result.ok) {
        throw new Error(result.data.description || result.data.message || 'Could not add to cart.');
      }
      confirmBtn.textContent = '✓ Added to cart';
      refreshCartCount();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('on:cart:add'));
      setTimeout(closeModal, 900);
    })
    .catch(function (err) {
      errorEl.textContent = err.message || 'Could not add to cart.';
      errorEl.hidden = false;
      confirmBtn.disabled = false;
      confirmBtn.textContent = 'Add to cart';
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var n = cart.item_count;
        document.querySelectorAll('[data-cart-count], .cart-count, .count-badge[data-badge="cart"]').forEach(function (el) {
          el.textContent = n;
          if (el.hasAttribute('data-count')) el.setAttribute('data-count', n);
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* PCL — Newsletter form → Kit (Promotions Flyer automation).
   Uses Kit's official embed script (UID 23d2286086) to ensure
   the right submission endpoint + hidden fields + double-opt-in
   handling. Kit's script is loaded invisibly; our visible
   footer form is unchanged. On submit we pipe the email into
   Kit's hidden form and trigger its native submit. */
(function () {
  'use strict';

  var KIT_UID = '23d2286086';
  var KIT_SCRIPT_SRC = 'https://pro-church-lights.kit.com/' + KIT_UID + '/index.js';

  var kitHost, kitScriptLoaded = false, pendingEmail = null;

  function ensureKitLoaded() {
    if (kitHost) return;
    kitHost = document.createElement('div');
    kitHost.id = 'pcl-kit-host';
    kitHost.setAttribute('aria-hidden', 'true');
    kitHost.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden;visibility:hidden;';
    document.body.appendChild(kitHost);

    var s = document.createElement('script');
    s.async = true;
    s.setAttribute('data-uid', KIT_UID);
    s.src = KIT_SCRIPT_SRC;
    s.onload = function () { kitScriptLoaded = true; tryFlushPending(); };
    kitHost.appendChild(s);
  }

  function findKitForm() {
    return kitHost && kitHost.querySelector('form.formkit-form, form[data-sv-form]');
  }

  function submitViaKit(email, onDone) {
    var kitForm = findKitForm();
    if (!kitForm) return false;
    var emailField = kitForm.querySelector('input[name="email_address"], input[type="email"]');
    if (!emailField) return false;
    emailField.value = email;
    emailField.dispatchEvent(new Event('input', { bubbles: true }));
    emailField.dispatchEvent(new Event('change', { bubbles: true }));
    emailField.dispatchEvent(new Event('blur', { bubbles: true }));
    // Trigger Kit's own submit handler. Prefer requestSubmit (fires submit event
    // through form validation + any script-added listeners) over a button click.
    try {
      if (typeof kitForm.requestSubmit === 'function') {
        kitForm.requestSubmit();
      } else {
        kitForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    } catch (err) {
      var submitBtn = kitForm.querySelector('button[data-element="submit"], button[type="submit"]');
      if (submitBtn) submitBtn.click();
    }
    if (onDone) onDone();
    return true;
  }

  function tryFlushPending() {
    if (!pendingEmail) return;
    var attempts = 0;
    var interval = setInterval(function () {
      attempts += 1;
      if (submitViaKit(pendingEmail)) {
        pendingEmail = null;
        clearInterval(interval);
      } else if (attempts > 40) {
        clearInterval(interval);
        pendingEmail = null;
      }
    }, 150);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('newsletter-form')) return;

    e.preventDefault();
    e.stopPropagation();

    var emailInput = form.querySelector('input[type="email"]');
    var email = emailInput ? (emailInput.value || '').trim() : '';
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showMessage(form, 'Please enter a valid email address.', 'error');
      return;
    }

    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;

    ensureKitLoaded();

    if (!submitViaKit(email)) {
      pendingEmail = email;
      tryFlushPending();
    }

    showMessage(form, 'Thank you for subscribing!', 'success');
    form.reset();
    if (btn) setTimeout(function () { btn.disabled = false; }, 600);
  }, true);

  function showMessage(_form, text, type) {
    document.querySelectorAll('.pcl-newsletter-toast, .pcl-newsletter-modal').forEach(function (el) { el.remove(); });

    if (type !== 'success') {
      var toast = document.createElement('div');
      toast.className = 'pcl-newsletter-toast pcl-newsletter-toast-' + type;
      toast.setAttribute('role', 'alert');
      toast.setAttribute('aria-live', 'assertive');
      toast.textContent = text;
      document.body.appendChild(toast);
      setTimeout(function () { toast.remove(); }, 4200);
      return;
    }

    var modal = document.createElement('div');
    modal.className = 'pcl-newsletter-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Subscription confirmation');
    modal.innerHTML =
      '<div class="pcl-newsletter-modal-backdrop" data-pcl-close></div>' +
      '<div class="pcl-newsletter-modal-panel">' +
        '<button type="button" class="pcl-newsletter-modal-close" aria-label="Close" data-pcl-close>&times;</button>' +
        '<div class="pcl-newsletter-modal-icon" aria-hidden="true">' +
          '<svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>' +
            '<polyline points="22 4 12 14.01 9 11.01"></polyline>' +
          '</svg>' +
        '</div>' +
        '<h3 class="pcl-newsletter-modal-title">Thank you for subscribing!</h3>' +
        '<p class="pcl-newsletter-modal-body">The Promotions Flyer is on its way to your inbox — keep an eye out for it.</p>' +
        '<button type="button" class="pcl-newsletter-modal-cta" data-pcl-close>Got it</button>' +
      '</div>';

    function closeModal() {
      modal.classList.add('is-closing');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { if (modal.parentNode) modal.parentNode.removeChild(modal); }, 200);
    }
    function onKey(e) {
      if (e.key === 'Escape') closeModal();
    }

    modal.addEventListener('click', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-pcl-close')) closeModal();
    });
    document.addEventListener('keydown', onKey);

    document.body.appendChild(modal);
  }

  // Warm up Kit's script as soon as we have a newsletter form on the page
  function warmup() {
    if (document.querySelector('.newsletter-form')) ensureKitLoaded();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', warmup);
  } else {
    warmup();
  }
})();
